<template>
  <b-container class="rounded contents p-4">
    <section class="p-4" v-if="!loading">
      <router-link
        tag="h3"
        to="/my-plan/details"
        class="myplan-form-header mb-4 font-weight-bold cursor-pointer"
      >
        <img
          src="../../assets/images/caret-left-2.svg"
          alt="caret-left"
          class="pl-2 pb-1"
        />
        Manage Subscription
      </router-link>
      <div class="rounded shadow bg-white mb-4">
        <div class="p-4">
          <h3 class="box-title">Would you like to cancel your subscription?</h3>
          <b-form-group
            :invalid-feedback="errorMessage('message')"
            id="descriptionGroup"
            label-for="reason_for_cancellation"
            :label="'Reason for Cancellation'"
            label-class="text-muted font-weight-bold"
            class="form-group secondary-label pt-3 mb-1"
          >
            <b-form-textarea
              placeholder="Enter reason for cancellation"
              :rows="6"
              :max-rows="6"
              :maxlength="500"
              v-model="form.message"
              :state="isValid('message')"
              class="bg-light"
            >
            </b-form-textarea>
          </b-form-group>
          <p class="text-muted">{{ reasonCharCount }}/{{ reasonMaxLength }}</p>

          <b-button
            variant="outline"
            class="px-4 mb-5"
            @click="submitCancellation"
            >Yes, cancel my subscription</b-button
          >

          <!-- <h3 class="box-title mb-2">Request to pause your subscription?</h3>
          <h4>Contact <span> activation@rush.ph</span></h4> -->
        </div>

        <hr class="m-0" />
      </div>
    </section>
    <b-modal id="confirm-cancel-subscription" title="Confirm" centered>
      <p class="text-center">
        Are you sure you want to cancel your subscription?
      </p>
      <template slot="modal-footer">
        <b-button @click="handleCancel">Cancel</b-button>
        <b-button variant="primary" @click="confirmCancelSubscription"
          >Yes, cancel my subscription</b-button
        >
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";

function initForm() {
  return {
    message: null,
  };
}

export default {
  name: "ManageSubscription",
  data() {
    return {
      reasonMaxLength: 500,
      form: initForm(),
      errors: null,
    };
  },
  computed: {
    ...mapState("myPlan", ["plan"]),
    ...mapGetters({
      loading: "myPlan/loading",
      plan: "myPlan/plan",
      user: "auth/user",
    }),
    reasonCharCount() {
      if (!this.form.message) return 0;

      return this.form.message.replace(/<[^>]*>?/gm, "").trim().length;
    },
  },
  created() {
    this.getPlanDetails();
  },
  methods: {
    ...mapActions({
      getPlanDetails: "myPlan/getPlanDetails",
      cancelSubscription: "myPlan/cancelSubscription",
    }),
    errorMessage(field) {
      return this.errors && this.errors[field] ? this.errors[field] : null;
    },
    isValid(field) {
      return this.errors && this.errors[field] ? false : null;
    },
    submitCancellation() {
      const errors = {};
      if (!this.form.message) errors["message"] = "This field is required.";
      this.errors = errors;

      if (!this.errors || Object.keys(this.errors).length === 0) {
        this.$nextTick(() => {
          this.$root.$emit("bv::show::modal", "confirm-cancel-subscription");
        });
      }
    },
    async confirmCancelSubscription() {
      const payload = {
        merchant_uuid: this.user.merchant_uuid,
        plan_uuid: this.plan.plan_uuid,
        reason_for_cancellation: this.form.message,
      };

      await this.cancelSubscription(payload);
      if (!this.errors || Object.keys(this.errors).length === 0) {
        this.$nextTick(() => {
          this.$root.$emit("bv::hide::modal", "confirm-cancel-subscription");
          this.$root.$emit("subscriptionCancelled");
        });
      }
    },
    handleCancel() {
      this.$root.$emit("bv::hide::modal", "confirm-cancel-subscription");
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  &.btn-outline {
    border-radius: 74px;
    border: solid 1.5px #000;
    font-size: 16px;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
  }
  &.btn-ghost {
    color: #5182ff;
    font-size: 14px;
    font-family: MainFontRegular, sans-serif;
  }
}

h4 {
  font-size: 15px;
  font-family: MainFontRegular, sans-serif;

  span {
    color: #5f8cff;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
  }
}
</style>
